import * as React from 'react';
import { Dispatch } from 'redux';
import axios, { AxiosError } from 'axios';
import { receiveAxiosError } from '@konicaminolta/common-react';
import { Card, Col, Row, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { format } from "date-fns";
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { DatasetRefreshHistory } from '../../types/DatasetRefreshHistory/DatasetRefreshHistory';

type DatasetRefreshHistoryTableProps = {
    dispatch: Dispatch;
    datasetId: string;
}

interface DatasetRefreshHistoryTableState {
    data: DatasetRefreshHistory[];
    isLoading: boolean;
    hasPermissions: boolean;
}


class DatasetRefreshHistoryTable extends React.Component<DatasetRefreshHistoryTableProps, DatasetRefreshHistoryTableState> {
    public constructor(props: DatasetRefreshHistoryTableProps) {
        super(props);
        this.state = {
            data: [],
            isLoading: true,
            hasPermissions: false,
        };
    }


    public componentDidMount() {
        this.getDatasetRefreshHistoryRecords();
    }

    private getDatasetRefreshHistoryRecords() {
        axios
            .get<DatasetRefreshHistory[]>(
                `./api/datasetrefreshhistory/${this.props.datasetId}`
            )
            .then((response) => {
                const { data } = response;
                this.setState({ data: data, isLoading: false, hasPermissions: true });
            })
            .catch((e: AxiosError) => {
                if (e.response && e.response.status == 401) {
                    this.setState({hasPermissions: false});
                }
                else if (e.response && e.response.status !== 404) {
                    this.props.dispatch(receiveAxiosError({ error: e }));
                }
                this.setState({ isLoading: false });
            });
    }

    render() {
        const NoDataComponent: React.FunctionComponent = (): React.ReactElement => {
            if (!this.state.isLoading && !this.state.hasPermissions) {
                return (
                    <div className="d-flex justify-content-center mt-3" data-cy="bootstrap-table-loaded">
                        <p className="text-center">Insufficient permissions to view refresh history.</p>
                    </div>
                );
            }
            if (!this.state.isLoading) {
                return (
                    <div className="d-flex justify-content-center mt-3" data-cy="bootstrap-table-loaded">
                        <p className="text-center">No dataset refresh history was found.</p>
                    </div>
                );
            }
            else {
                return (
                    <div className="d-flex justify-content-center mt-3">
                        <Spinner animation="border" variant="primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                );
            }
        };

        const { SearchBar } = Search;

        const columns = [
            {
                dataField: 'id',
                text: 'Id',
                sort: true,
            },
            {
                dataField: 'refreshType',
                text: 'Refresh Type',
                sort: true,
            },
            {
                dataField: 'startTimeUtc',
                text: 'Start Time',
                sort: true,
                formatter: (cell: string, row: DatasetRefreshHistory) => {
                    return format(new Date(cell), 'yyyy-MM-dd hh:mm:ss');
                },
            },
            {
                dataField: 'endTimeUtc',
                text: 'End Time',
                sort: true,
                formatter: (cell: string, row: DatasetRefreshHistory) => {
                    return format(new Date(cell), 'yyyy-MM-dd hh:mm:ss');
                },
            },
            {
                dataField: 'status',
                text: 'Status',
                sort: true,
            }
        ];


        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <Card className="panel">
                            <Card.Header>
                                <Row>
                                    <Col md={6}>
                                        <h3>Dataset Refresh History</h3>
                                    </Col>
                                    <Col md={6} className='text-end'>
                                        {/*<Button variant='primary' className='ms-3' onClick={() => this.handleOpenAddAliasModal()}>Add Alias</Button>*/}
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                <ToolkitProvider
                                    keyField="id"
                                    search
                                    data={this.state.data}
                                    columns={columns}
                                >
                                    {
                                        props => (
                                            <React.Fragment>
                                                <Row>
                                                    <Col>
                                                        <SearchBar {...props.searchProps} />
                                                    </Col>
                                                </Row>
                                                <BootstrapTable
                                                    {...props.baseProps}
                                                    id="datasetRefreshHistoryTable"
                                                    classes='clickable'
                                                    striped
                                                    hover
                                                    bordered={false}
                                                    defaultSorted={[{ dataField: 'endTimeUtc', order: 'desc' }]}
                                                    pagination={paginationFactory({ sizePerPage: 10 })}
                                                    noDataIndication={() => <NoDataComponent />}
                                                //rowEvents={ }
                                                />
                                            </React.Fragment>
                                        )
                                    }
                                    </ToolkitProvider>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

export default DatasetRefreshHistoryTable;